import { combineReducers } from 'redux';

import { LOGOUT_REQUEST } from './auth/auth-constants';

import app from './app/app-reducer';
import auth from './auth/auth-reducer';
import user from './user/user-reducer';
import team from './team/team-reducer';
import rewards from './rewards/rewards-reducer';
import sponsored from './sponsored/sponsored-reducer';
import trading from './trading/trading-reducer';
import order from './order/order-reducer';
import configuration from './configuration/configuration-reducer';
import tenant from './tenant/tenant-reducer';
import promotion from './promotion/promotion-reducer';
import accessProfile from './access-profile/access-profile-reducer';
import loadType from './load-type/load-type-reducer';
import loadControl from './load-control/load-control-reducer';
import client from './client/client-reducer';
import reason from './reason/reason-reducer';
import product from './product/product-reducer';
import productList from './product-list/product-list-reducer';
import orderType from './order-type/order-type-reducer';
import notifications from './notifications/notifications-reducer';
import productKit from './product-kit/product-kit-reducer';
import orderSplit from './order-split/order-split-reducer';
import ratings from './ratings/ratings-reducer';
import salesTracking from './sales-tracking/sales-tracking-reducer';
import clientVisit from './client-visit/client-visit-reducer';
import productPhotos from './product-photos/product-photos-reducer';
import controlNotifications from './control-notifications/control-notifications-reducer';
import clientChecklist from './client-checklist/client-checklist-reducer';
import clientReportsChecklist from './client-report-checklist/client-report-checklist-reducer';
import justifications from './justifications/justifications-reducer';
import promotionKitReport from './promotion-kit-report/promotion-kit-report-reducer';
import auditUser from './audit-user/audit-user-reducer';
import bonificationProduct from './bonification-product/bonification-product-reducer';
import focusSupplier from './focus-supplier/focus-supplier-reducer';
import dailyRoute from './daily-route/daily-route-reducer';
import dailyRouteReport from './daily-route-report/daily-route-report-reducer';
import productTechnical from './product-technical/product-technical-reducer';
import selectPagination from './select-pagination/select-pagination-reducer';
import vendorClientVisit from './vendor-client-visit/vendor-client-visit-reducer';
import commissionReport from './commission-report/commission-report-reducer';
import clientPositionReport from './client-position-report/client-position-report-reducer';
import routing from './routing/routing-reducer';
import routedClientsReport from './routed-clients-report/routed-clients-report-reducer';
import productWithoutPictureReport from './product-without-picture-report/product-without-picture-report-reducer';
import mandatoryMix from './mandatory-mix/mandatory-mix-reducer';

const appReducer = combineReducers({
  app,
  auth,
  user,
  team,
  rewards,
  sponsored,
  trading,
  order,
  orderType,
  configuration,
  tenant,
  promotion,
  accessProfile,
  loadType,
  loadControl,
  client,
  reason,
  product,
  productList,
  notifications,
  productKit,
  orderSplit,
  ratings,
  salesTracking,
  clientVisit,
  productPhotos,
  controlNotifications,
  clientChecklist,
  clientReportsChecklist,
  justifications,
  promotionKitReport,
  auditUser,
  bonificationProduct,
  focusSupplier,
  dailyRoute,
  dailyRouteReport,
  productTechnical,
  selectPagination,
  vendorClientVisit,
  commissionReport,
  clientPositionReport,
  routing,
  routedClientsReport,
  productWithoutPictureReport,
  mandatoryMix
});

const rootReducer = (state: any, action: any) => {
  if (action.type === LOGOUT_REQUEST) {
    state = {
      app: { ...state.app }
    };
  }

  return appReducer(state, action);
};

type RootReducerType = typeof appReducer;
export type AppStateType = ReturnType<RootReducerType>;

export default rootReducer;
